import angular from 'angular';
import authFactory from './jwt/auth.factory'

let sharedProvidersModule = angular.module('shared.providers', [])
    .factory('AuthInterceptor', authFactory.AuthInterceptor)
    .factory('AuthTokenFactory', authFactory.AuthTokenFactory);

export default sharedProvidersModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/providers/shared-providers.js
 **/